import { header } from "../../../setup/settings/__home";

export default function PhoneHeader() {
    if (header.phoneIcon) return <img src={header.phoneIcon} />
    else return (
        <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.705 10.5317C11.7863 10.5317 10.8975 10.3688 10.0684 10.0754C9.80698 9.97767 9.51568 10.051 9.31401 10.271L8.14136 11.8762C6.02759 10.7762 4.04827 8.69841 2.99512 6.311L4.45161 4.95841C4.65327 4.73026 4.71302 4.41248 4.63086 4.1273C4.35451 3.22285 4.21259 2.25322 4.21259 1.251C4.21259 0.811003 3.87648 0.444336 3.47315 0.444336H0.888827C0.485494 0.444336 0 0.639892 0 1.251C0 8.82063 5.77364 15.111 12.705 15.111C13.2353 15.111 13.4444 14.5977 13.4444 14.1495V11.3384C13.4444 10.8984 13.1083 10.5317 12.705 10.5317Z" fill="#43656E" />
        </svg>

    )
}